export class ContainerTranslation
{
    id: number;
    locale: string;
    name: string;
    column_1_name: string;
    column_2_name: string;

}
